import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { SdkService } from "src/app/sdk.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-biometric-capture",
  templateUrl: "./biometric-capture.component.html",
  styleUrls: ["./biometric-capture.component.scss"],
})
export class BiometricCaptureComponent implements OnInit {
  isLoading = true;
  webhook: string;
  auth_key: string;
  identifier: string;
  finger_capture: string;
  showCapture = false;
  // selectedFinger: any;

  leftthumb: any;
  leftindex: any;
  leftmiddle: any;
  leftring: any;
  leftlittle: any;
  rightthumb: any;
  rightindex: any;
  rightmiddle: any;
  rightring: any;
  rightlittle: any;

  clearedFace: string;

  // imgPath: "data:image/png;base64, ";
  base64Image: any;
  base64String: any;

  constructor(
    private router: Router,
    private sdkService: SdkService,
    private readonly route: ActivatedRoute,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.webhook = this.route.snapshot.params["webhook"];
    this.auth_key = this.route.snapshot.params["auth_key"];
    this.identifier = this.route.snapshot.params["identifier"];
    // this.selectedFinger = this.route.snapshot.params["finger_option"];
    // console.log("selectedFinger ::", this.selectedFinger);

    var requestOptions: any = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `https://mtn-services.verxid.site/mtn-services/v1/authCheck?auth_key=${this.auth_key}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status && result.status == 1) {
          this.isLoading = false;

          // call finger capture method
          this.captureFinger();
          // this.captureFinger(this.selectedFinger);
        } else {
          Swal.fire({
            title: "Error!",
            text: result.message,
            icon: "error",
            showConfirmButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Retry",
          });
        }

        this.leftindex = this._sanitizer.bypassSecurityTrustResourceUrl(
          `data:image/png;base64, ${this.leftindex}`
        );
      })
      .catch((error) => {
        // console.log("error", error);
      });

    // set this to a valid base64 image
    // this.base64Image =
  }

  transform(base64String) {
    return `data:image/png;base64, ${base64String}`;
  }

  refreshCapture() {
    window.location.reload();
  }

  // captureFinger(selectedFinger) {
  captureFinger() {
    this.sdkService
      .capture_finger()
      // .capture()
      .then((res) => {
        // call logger service
        var requestOptions: any = {
          method: "GET",
          redirect: "follow",
        };

        fetch(
          `https://mtn-services.verxid.site/mtn-services/v1/logFingerCapture?api_key=${this.auth_key}`,
          requestOptions
        )
          .then((response) => response.text())
          // .then((result) => console.log(result))
          .catch((error) => console.log("error", error));

        console.log("this is the finger capture ==>>", res);
        this.finger_capture = res.data;
        // this.leftthumb = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(LEFT,THUMB)"].templates.PNG.DEFAULT}`
        // );
        // this.leftindex = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(LEFT,INDEX)"].templates.PNG.DEFAULT}`
        // );
        // this.leftlittle = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(LEFT,LITTLE)"].templates.PNG.DEFAULT}`
        // );
        // this.leftmiddle = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(LEFT,MIDDLE)"].templates.PNG.DEFAULT}`
        // );
        // this.leftring = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(LEFT,RING)"].templates.PNG.DEFAULT}`
        // );
        // this.rightthumb = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(RIGHT,THUMB)"].templates.PNG.DEFAULT}`
        // );
        // this.rightindex = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(RIGHT,INDEX)"].templates.PNG.DEFAULT}`
        // );
        // this.rightlittle = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(RIGHT,LITTLE)"].templates.PNG.DEFAULT}`
        // );
        // this.rightmiddle = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(RIGHT,MIDDLE)"].templates.PNG.DEFAULT}`
        // );
        // this.rightring = this._sanitizer.bypassSecurityTrustResourceUrl(
        //   `data:image/png;base64, ${res.data["(RIGHT,RING)"].templates.PNG.DEFAULT}`
        // );

        const responseData = {
          status: 200,
          message: "Finger capture successful",
          // finger_data: {
          //   leftthumb: this.leftthumb,
          //   leftindex: this.leftindex,
          //   leftmiddle: this.leftmiddle,
          //   leftring: this.leftring,
          //   leftlittle: this.leftlittle,
          //   rightthumb: this.rightthumb,
          //   rightindex: this.rightindex,
          //   rightmiddle: this.rightmiddle,
          //   rightring: this.rightring,
          //   rightlittle: this.rightlittle,
          // },
          finger_data: this.finger_capture,
          auth_key: this.auth_key,
          identifier: this.identifier,
        };

        window.parent.postMessage(responseData, "*");

        this.showCapture = true;
      })
      .catch((err) => {
        Swal.fire({
          title: "capture Failed!",
          text: "Finger biometrics capture failed",
          icon: "error",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Try Again",
        }).then((isConfirm) => {
          if (isConfirm.isConfirmed) {
            this.captureFinger();
            // this.captureFinger(this.selectedFinger);
          }
        });
        window.parent.postMessage(
          {
            identifier: this.identifier,
            auth_key: this.auth_key,
            status: 400,
            message: "Capture failed!",
          },
          "*"
        );
        // console.log(err);
      });
  }
}
